import { Button } from '@steelwake/ui';
import { useState, type FormEvent } from 'react';
import { Link } from 'react-router';

import { api, describeError } from '../api.js';
import { Card, Field, Notice, PageTitle } from '../ui.js';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState<string | null>(null);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const res = await api<{ message: string }>('/api/v1/auth/forgot-password', {
        method: 'POST',
        body: { email },
      });
      setDone(res.message);
    } catch (err) {
      setError(describeError(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Card>
      <PageTitle>Reset your password</PageTitle>
      {done ? (
        <Notice kind="success" testId="forgot-success">
          {done}
        </Notice>
      ) : (
        <form onSubmit={submit} noValidate>
          <Field
            label="Email"
            name="email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {error ? (
            <Notice kind="error" testId="form-error">
              {error}
            </Notice>
          ) : null}
          <Button type="submit" disabled={busy}>
            {busy ? 'Sending…' : 'Send reset link'}
          </Button>
        </form>
      )}
      <p>
        <Link to="/login">Back to log in</Link>
      </p>
    </Card>
  );
}
